export enum XrayTab {
  FileMetadata = 'file-metadata',
  Metadata = 'metadata',
  Font = 'font',
  Size = 'size',
  TextBreakups = 'text-breakups',
  ActiveFields = 'active-fields',
  ByteCode = 'byte-code',
  SimilarDocuments = 'similar-documents'
}

export enum XrayTabGroup {
  Metadata = 'metadata',
  TextProperties = 'text-properties',
  ByteCode = 'byte-code',
  SimilarDocuments = 'similar-documents'
}
